import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({

    buttonWrapper: {
        '& > :hover': {
            cursor: 'pointer',
            backgroundColor: theme.palette.greyFour.main,
        }
    },
    progress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -20,
        marginLeft: -20,
    },
    action: {
        width: '100%',
        position: 'relative',
        backgroundColor: theme.palette.greyFour.light,
        transition: theme.transitions.create(['background-color'], {
            duration: theme.transitions.duration.short,
        }),
        textAlign: 'center',
        color: theme.palette.greyTwo.main,
        borderRadius: theme.spacing(1),
        paddingTop: theme.spacing(1) + theme.spacing(1) / 2,
        paddingBottom: theme.spacing(1) + theme.spacing(1) / 2,
        height: theme.spacing(10)
    },
    activeAction: {
        color: theme.palette.primary.main,
    },
    actionIcon: {
        fontSize: '3rem !important',
    },
    disabled: {
        color: theme.palette.action.disabled + '!important',
        backgroundColor: theme.palette.action.disabledBackground
    },
    disabledForeground: {
        color: theme.palette.action.disabled + '!important',
    }

}))

export const FingotiActionButton = ({ Icon, label, active, disabled, loading, onClick }) => {

    const classes = useStyles();

    return (
        <div onClick={!disabled && !loading ? onClick : () => { }} className={clsx(classes.buttonWrapper)}>
            <div className={clsx(classes.action, { [classes.disabled]: disabled || loading })}>
                <Icon className={clsx(classes.actionIcon, { [classes.disabledForeground]: disabled || loading, [classes.activeAction]: active })} />
                <Typography>{label}</Typography>
                {loading && <CircularProgress size={40} className={classes.progress} />}
            </div>
        </div>
    )

}

FingotiActionButton.defaultProps = {
    label: "",
    active: false,
    disabled: false,
    loading: false,
    onClick: () => { }
}

FingotiActionButton.propTypes = {
    Icon: PropTypes.node.isRequired,
    label: PropTypes.string,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func
}